import { Presentation, ImageWithMetadata } from '@features/powerpoint';
import { createSharedPresentationConfig as createSharedPresentationConfigV1 } from '../../../utils/shared-presentation-config';
import { createSharedPresentationConfigV2 } from '../../../utils/shared-presentation-config-v2';
import { Campaign, UseCalculatedFieldsReturn } from '@features/campaigns';
import { Lci3Report } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { DEFAULT_FILENAME } from '../../../utils/constants';
import { FormSchema as FormSchemaV1 } from '../form-schema';
import { FormSchema as FormSchemaV2 } from '../domain/v2/form-schema';
import { SubdimensionsByName } from '@features/reports/subdomains/visitation';
import { SubdimensionCounts } from '@features/reports';
import { buildSlidesV2 } from './build-slides-v2';
import { buildSlidesV1 } from './build-slides-v1';
import { buildSlideMasters } from '@features/executive-report/utils/slide-masters';

export type BuildReportOptions = {
  campaign: Pick<Campaign, 'id' | 'name' | 'startDate' | 'endDate'>;
  currentReport: Pick<
    Lci3Report,
    'startDate' | 'reportDate' | 'salesMetrics' | 'visitMetrics'
  >;
  brandLogo: ImageWithMetadata | null;
  midCampaignSalesMetrics: Lci3Report['salesMetrics'];
  midCampaignIncrementalLift: Lci3Report['visitMetrics']['incrementalLift'];
  currentSalesMetrics: Lci3Report['salesMetrics'];
  campaignAnalyticsReport: CampaignAnalyticsReport | null;
  topVisitSubdimensionsByName: SubdimensionsByName;
  topSalesSubdimensionsByName: SubdimensionsByName;
  subdimensionCounts: SubdimensionCounts;
  calculatedFields: UseCalculatedFieldsReturn['data'];
} & (
  | {
      designVersion: 'v1';
      customFields: FormSchemaV1;
    }
  | {
      designVersion: 'v2';
      customFields: FormSchemaV2;
    }
);

export const buildPresentation = (
  options: BuildReportOptions
): Presentation => {
  const { slides, createSharedPresentationConfig } = (() => {
    if (options.designVersion === 'v1') {
      return {
        slides: buildSlidesV1(options),
        createSharedPresentationConfig: createSharedPresentationConfigV1,
      };
    }

    return {
      slides: buildSlidesV2(options),
      createSharedPresentationConfig: (
        brandLogo: BuildReportOptions['brandLogo']
      ) => createSharedPresentationConfigV2(buildSlideMasters(brandLogo)),
    };
  })();

  return {
    ...createSharedPresentationConfig(options.brandLogo),
    filename: [options.campaign.name, DEFAULT_FILENAME].join(' - '),
    slides,
  };
};
